import React, { Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { IFileListPageProps, IFileListPageState } from '../../../models/pages/addedActivityFiles';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import { Redirect } from 'react-router-dom';
import CActivityFileList from './tabs/activity-file-page';
import CAssigmentFileList from './tabs/assigment-file-page';
import CDeletedFileList from './tabs/deleted-file-page';
import * as Actions from '../../../store/actions/storageManagement';
import Loading from '../../../components/loading/loading';
import ContentLoader from 'react-content-loader';
import { ActivityAddedFileTabNumbers } from '../../../models/enums/StorageManagement';
import ReactGA from 'react-ga4';

const _logger = Log.create('content.tsx');
const T = Translator.create();
const _common = new Common();

export class FileListPage extends React.Component<IFileListPageProps, IFileListPageState> {
    public state: IFileListPageState = {
        goToTermListPage: false,
        termId: '',
        termName: '',
        tab: ActivityAddedFileTabNumbers.activity_files
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        let getTermId: any;
        let getTermName: any;
        let params = new URLSearchParams(this.props.location.search);
        getTermId = params.get('term_id');
        getTermName = params.get('term_name');
        this.setState({
            ...this.state,
            termId: getTermId,
            termName: getTermName
        })

        if (getTermId && getTermId != '') {
            this.getGeneralStatistics(getTermId);
        }
    }

    getGeneralStatistics(termId: string) {
        this.props.dispatch(Actions.ActivityFilesStatisticsByTerm(termId, "activityFilesStatisticsByTerm"));
    }

    getTab(tab: any) {
        if (tab == "activityFiles")
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_ACTIVITY_FILES_CLICKED',
                label:'G_ACTIVITY_FILES_CLICKED', 
                nonInteraction: true, 
            }); 
        }
        else if(tab == "assignmentFiles")
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_ASSIGNMENT_FILES_CLICKED',
                label:'G_ASSIGNMENT_FILES_CLICKED', 
                nonInteraction: true, 
            }); 
        }
        else if(tab == "deletedFiles")
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_DELETED_FILES_CLICKED',
                label:'G_DELETED_FILES_CLICKED', 
                nonInteraction: true, 
            }); 
        }
        this.setState({
            ...this.state,
            tab: tab,
        })
    }

    public render() {
        const componentSpacing = 80;

        if (this.state.goToTermListPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/files-added-activities/'} />
        }

        return (
            <div className="student-course  activities-dashboard">
                <div className="container">
                    <div style={{ paddingTop: 0, paddingBottom: 10 }} className="row student-course-header question-filter">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h2>{this.state.termName}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 text-md-right">
                            <a onMouseDown={() => {
                                ReactGA.event({
                                    category: window.location.host,
                                    action: 'G_TERM_LIST_BACK_BUTTON_CLICKED',
                                    label:'G_TERM_LIST_BACK_BUTTON_CLICKED', 
                                    nonInteraction: true, 
                                }); 
                                this.setState({ goToTermListPage: true })
                            }} 
                            style={{ fontSize: "12px" }}>
                                {T.t('r_gen_term_selection_back')}
                                <i className="material-icons ml-2 align-middle" style={{ fontSize: "17px" }}>arrow_forward</i>
                            </a>
                        </div>
                    </div>
                    {/* <Loading spinnerId={'activityFilesStatisticsByTerm'} >
                        <div style={{ backgroundColor: '#fbfaf6' }}>
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                viewBox="0 0 730 150"
                                style={{ width: '100%', marginTop: '-140px' }}
                            >
                                <circle cx="70" cy={34 + componentSpacing} r="20" />
                                <rect x="100" y={20 + componentSpacing} rx="3" ry={8 + componentSpacing} width="100" height="3" />
                                <rect x="100" y={45 + componentSpacing} rx="3" ry={8 + componentSpacing} width="60" height="6" />

                                <circle cx="310" cy={34 + componentSpacing} r="20" />
                                <rect x="340" y={20 + componentSpacing} rx="3" ry={8 + componentSpacing} width="100" height="3" />
                                <rect x="340" y={45 + componentSpacing} rx="3" ry={8 + componentSpacing} width="60" height="6" />

                                <circle cx="570" cy={34 + componentSpacing} r="20" />
                                <rect x="600" y={20 + componentSpacing} rx="3" ry={8 + componentSpacing} width="100" height="3" />
                                <rect x="600" y={45 + componentSpacing} rx="3" ry={8 + componentSpacing} width="60" height="6" />
                            </ContentLoader>
                        </div>
                    </Loading> */}
                    <div className="row">
                        {this.props.activityFilesStatisticsByTerm && this.props.activityFilesStatisticsByTerm.length > 0 ? (
                            this.props.activityFilesStatisticsByTerm.map((item: any, index: any) => {

                                let iconNameByItemName = item.itemName === "activityFilesSize" ? 'filledperson' :
                                    item.itemName === "assignmentFilesSize" ? 'filledeye' : 'filleddownload';

                                let itemName = item.itemName === "activityFilesSize" ? T.t('r_gen_activity_files') :
                                    item.itemName === "assignmentFilesSize" ? T.t('r_gen_assigment_files_students') : T.t('r_gen_deleted_files');

                                return (
                                    <div className="col d-flex justify-content-center">
                                        <div className="report_icon">
                                            <img src={_common.GetDefaultIcons(iconNameByItemName)} alt="" />
                                        </div>
                                        <div className="report_icon_text">
                                            <span className="icon_text_medium">{itemName}</span>
                                            <span className="icon_text_small">{_common.BytesToSize(item.fileSize)}</span>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (null
                        )}
                    </div>
                    <div className="row">
                        <div className=" col-12 modal-tabs session_tabs px-0">
                            <ul className="nav nav-tabs border-0" style={{paddingInlineStart: '0px'}} id="exam-panel-tab-content" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active show" onClick={this.getTab.bind(this, ActivityAddedFileTabNumbers.activity_files)} id="active-tab" data-toggle="tab" href="#active" role="tab" aria-controls="active" aria-selected="true">{T.t('r_gen_activity_files')}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link " onClick={this.getTab.bind(this, ActivityAddedFileTabNumbers.assignment_files)} id="future-tab" data-toggle="tab" href="#future" role="tab" aria-controls="future" aria-selected="false">{T.t('r_gen_assigment_files_students')}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" onClick={this.getTab.bind(this, ActivityAddedFileTabNumbers.deleted_files)} id="past-tab" data-toggle="tab" href="#past" role="tab" aria-controls="past" aria-selected="false">{T.t('r_gen_deleted_files')}</a>
                                </li>
                            </ul>
                            <div className="tab-content" id="exam-panel-tab-content">
                                <div className="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                                    {
                                        (this.state.tab === ActivityAddedFileTabNumbers.activity_files) ?
                                            (
                                                <CActivityFileList />
                                            ) : ('')
                                    }
                                </div>
                                <div className="tab-pane fade" id="future" role="tabpanel" aria-labelledby="future-tab">
                                    {
                                        (this.state.tab === ActivityAddedFileTabNumbers.assignment_files) ?
                                            (
                                                <CAssigmentFileList />
                                            ) : ('')
                                    }
                                </div>
                                <div className="tab-pane fade" id="past" role="tabpanel" aria-labelledby="past-tab">
                                    {
                                        (this.state.tab === ActivityAddedFileTabNumbers.deleted_files) ?
                                            (
                                                <CDeletedFileList />
                                            ) : ('')
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IFileListPageProps) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IFileListPageProps = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        activityFilesStatisticsByTerm: state.storageManagement.activityFilesStatisticsByTerm,
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.storageManagement.activityFilesStatisticsByTerm === prev.storageManagement.activityFilesStatisticsByTerm;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CFileListPage = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(FileListPage);

export default CFileListPage;

